export const UPDATE_FILES_LIST = 'UPDATE_FILES_LIST';
export const UPDATE_TEMPLATES_LIST = 'UPDATE_TEMPLATES_LIST';
export const UPDATE_FILE = 'UPDATE_FILE';
export const UPDATE_TEMPLATE = 'UPDATE_TEMPLATE';
export const SELECT_TEMPLATE = 'SELECT_TEMPLATE';

export const REPLACE_TEMPLATE = 'REPLACE_TEMPLATE';
